import { usdPerUnit } from "@/constants/terminal/provider-rate"
import { UsageProvider } from "@/constants/terminal/usage-provider"
import type {
  PipelineUsage,
  UsageTotal,
} from "@/terminal/monitoring/monitoring-usage"
import { addTotal, emptyTotal } from "@/terminal/monitoring/usage-presentation"

// Pending and unknown attempts carry no quantity, so they stay counted, not
// priced: a dollar total is a floor until they settle.
const providerDollars = (provider: UsageProvider, total: UsageTotal) => ({
  ...total,
  known: total.known * usdPerUnit(provider),
  estimated: total.estimated * usdPerUnit(provider),
})

// A Run that never tracked provider usage prices only its LLM calls; the caller
// says so beside the total.
export const usageDollars = (usage: PipelineUsage) => {
  const byProvider = Object.fromEntries(
    Object.values(UsageProvider).map((provider) => [
      provider,
      providerDollars(provider, usage[provider]),
    ])
  ) as Record<UsageProvider, UsageTotal>
  const parts = usage.isProviderUsageTracked
    ? [usage.llm, ...Object.values(byProvider)]
    : [usage.llm]
  const total = emptyTotal()
  for (const part of parts) addTotal(total, part)
  return { byProvider, total }
}
